// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import { Button } from "@mui/material";
// import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { t } from "i18next";
// import { useState } from "react";
// import { getLocalStorageMenuItem, getPopupBorderRaduis, setMobileBackColor, setMobileCardBorderColor, setMobileTextColor } from "../../../utility";

// const LoadingTreeDataDialog = ({ openTreeDialogFlag, tableName, tableQr, from_home, openAvailability, onClose }) => {
//     const navigate = useNavigate();
//     const [params, setParams] = useSearchParams();
//     const language = getLocalStorageMenuItem("lang");


//     const handleHome = () => {
//         const baseUrl = `/${tableName}/${tableQr}/menus?lang=${language}`;
//         const tableParam = params.get("t");
//         const finalUrl = tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl;
//         window.location.href = finalUrl; 
//     };

//     const handleBtnAction = () => {
//         if (from_home) {
//             openAvailability();
//         } else {
//             handleHome();
//         }
//         if (onClose) onClose();
//     };

//     return (
//         <Dialog
//             open={openTreeDialogFlag}
//             onClose={onClose}
//             fullWidth
//             maxWidth="xs"
//             PaperProps={{
//                 sx: {
//                     borderRadius: getPopupBorderRaduis(),
//                     backgroundColor: setMobileTextColor(),
//                     color: setMobileBackColor(),
//                 },
//             }}
//             className="alignByLang"
//         >
//             <div className="p-24 text-center">
//                 <WarningAmberRoundedIcon
//                     fontSize="large"
//                     sx={{ fontSize: 80, color: setMobileBackColor() }}
//                 />
//                 <DialogTitle className="p-0 text-center head-font">
//                     {t("Error Loading Data")}
//                 </DialogTitle>
//                 <DialogContent className="p-0">
//                     <DialogContentText style={{ color: setMobileBackColor() }}>
//                         <p className="text-center sub-font">
//                             {t(
//                                 `This menu may not be available at this time,go to home screen to check the availabilities!`
//                             )}
//                         </p>
//                     </DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button
//                         style={{ backgroundColor: setMobileBackColor(), color: setMobileTextColor() }}
//                         className="button-height-sm mx-1 head-font"
//                         variant="contained"
//                         onClick={() => handleBtnAction()}
//                         fullWidth
//                     >
//                         {from_home ? t("Check Availability") : t("Home")}
//                     </Button>
//                 </DialogActions>
//             </div>
//         </Dialog>
//     );
// };

// export default LoadingTreeDataDialog;


import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, Box, Typography } from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import {
    getLocalStorageMenuItem,
    getPopupBorderRaduis,
    setMobileBackColor,
    setMobileCardBorderColor,
    setMobileTextColor,
} from "../../../utility";

const LoadingTreeDataDialog = ({
    openTreeDialogFlag,
    tableName,
    tableQr,
    from_home,
    openAvailability,
    onClose,
}) => {
    const navigate = useNavigate();
    const [params, setParams] = useSearchParams();
    const language = getLocalStorageMenuItem("lang");

    const handleHome = () => {
        const baseUrl = `/${tableName}/${tableQr}/menus?lang=${language}`;
        const tableParam = params.get("t");
        const finalUrl = tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl;
        window.location.href = finalUrl;
    };

    const handleBtnAction = () => {
        if (from_home) {
            openAvailability();
        } else {
            handleHome();
        }
        if (onClose) onClose();
    };

    return (
        <Dialog
            open={openTreeDialogFlag}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: getPopupBorderRaduis(),
                    backgroundColor: setMobileTextColor(),
                    color: setMobileBackColor(),
                    textAlign: "center",
                    p: 3,
                },
            }}
            className="alignByLang"
        >
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                <AccessTimeRoundedIcon
                    fontSize="large"
                    sx={{ fontSize: 80, color: setMobileBackColor() }}
                />

                <DialogTitle className="p-0 text-center head-font" sx={{ fontWeight: "bold" }}>
                    {t("We'll Be Back Soon")}
                </DialogTitle>

                <DialogContent className="p-0">
                    <DialogContentText style={{ color: setMobileBackColor() }}>
                        <Typography className="sub-font" variant="body1" sx={{ lineHeight: 1.6 }}>
                            {t(
                                "Our menu is currently being refreshed or temporarily unavailable. Please check again soon or return to the home screen to see other options."
                            )}
                        </Typography>
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ width: "100%", mt: 2 }}>
                    <Button
                        style={{
                            backgroundColor: setMobileBackColor(),
                            color: setMobileTextColor(),
                            borderRadius: 12,
                            padding: "10px 0",
                            fontWeight: "600",
                        }}
                        variant="contained"
                        onClick={handleBtnAction}
                        fullWidth
                    >
                        {from_home ? t("Check Availability") : t("Go Home")}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default LoadingTreeDataDialog;

